import request from '@/src/utils/request'

// 取得分店資料
export const getMerchantProductInfo = async (productId) => {
  const response = await request.get(`/admin/merchant/product/${productId}`)
  return response
}

// 取得店家資料
export const getMerchantInfo = async () => {
  const response = await request.get('/admin/merchant')
  return response
}
